import YesIcon from 'assets/images/yes-icon.svg';
import { ReactComponent as LeftArrowIcon } from 'assets/images/left-arrow.svg';
import { ReactComponent as RightArrowIcon } from 'assets/images/right-arrow.svg';
import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';
import Logo from 'assets/images/logo.svg';
import Theme from 'theme';

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_AWS_REGION: region,
  REACT_APP_COGNITO_POOL_ID: userPoolId,
  REACT_APP_COGNITO_WEB_CLIENT_ID: userPoolWebClientId,
  REACT_APP_CLIENT_HEADER: clientHeader = groupId,
  REACT_APP_APPPOINTMENT_LINK: bookAppointmentLink,
} = process.env;

const config = {
  groupId,
  region,
  userPoolId,
  userPoolWebClientId,
  logo: Logo,
  cptCodesIcon: YesIcon,
  portalName: 'dionhealth',
  tokenName: 'dionhealthSubscriberToken',
  globalClass: 'dionhealth-container',
  clientHeader,
  enableHeroButton: true,
  pricingType: 'standard-pricing',
  heroLocaleColor: 'secondary',
  headerProps: {
    enable: false,
  },
  homeTemplateProps: {
    heroSection: {
      variant: 2,
      titleClasses: 'home-hero-title',
      subTitleClasses: 'home-hero-subtitle',
      primaryButtonProps: {
        to: '/find-a-provider',
      },
      secondaryButtonProps: {
        to: '/login',
        color: 'primary',
      },
      background: '/images/home-images/home-banner-img.webp',
      backgroundMobile: '/images/home-images/home-banner-img.webp',
    },
    benefitsSection: {
      variant: 2,
      columns: 4,
      alignTitle: 'left',
      alignCard: 'left',
    },
    subscriptionSection: {
      tabVariant: 2,
      carouselResponsiveItems: {
        superLargeDesktop: 1,
        desktop: 1,
        tablet: 1,
        mobile: 1,
      },
      showAddons: false,
      primaryButtonProps: {
        color: 'primary',
      },
      addonProps: {
        showCptCodes: true,
        addonVariant: 2,
      },
      planCardProps: {
        showMonthlyPriceForAnnual: true,
      },
    },
    howItWorksSection: {
      variant: 1,
      heroImage: '/images/home-images/how-it-works.webp',
      primaryButtonProps: {
        variant: 'outlined',
        color: 'secondary',
      },
    },
    testimonialSection: {
      variant: 1,
      messageType: 'h6',
      gridSpacing: {
        xSmall: 12,
        medium: 12,
      },
      carouselResponsiveItem: {
        superLarge: 1,
        large: 1,
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      primaryButtonProps: {
        color: 'primary',
      },
    },
  },
  employer: {
    variant: 2,
    hubspotForm: {
      formId: "653137e2-eeb4-486d-8b3f-00143837b628",
      portalId: "40118398"
    },
    heroSection: {
      variant: 2,
      titleClasses: 'home-hero-title',
      subTitleClasses: 'home-hero-subtitle',
      showSubtitleDivider: true,
      primaryButtonProps: {
        to: '/find-a-provider',
      },
      secondaryButtonProps: {
        scrollTo: 'static-plan-cards',
        color: 'primary',
      },
      background: '/images/employer/employee-banner-img.webp',
    },
    benefitsSection: {
      variant: 6,
      columns: 3,
      customXS: 6,
      alignTitle: 'left',
      alignCard: 'left',
      sameLineIconText: 6,
    },
    metrics: {
      graphImg: '/images/employer/graph.webp',
    },
    subscriptionSection: {
      cardVariant: 5,
      tabVariant: 2,
      showMonthlyPriceForAnnual: true,
      renderAsCardGrid: true,
      frequencyPlans: true,
      offerText1Variant: 'body1',
      offerText2Link: '',
      offerText2Action: {
        type: 'popup',
        action: 'savings-summary',
      },
      gridModel: true,
      carouselResponsiveItems: {
        superLargeDesktop: 4,
        desktop: 4,
      },
      plansPerRow: {
        lg: 4,
      },
      showAddons: false,
      planCardProps: {
        cardGroup: true,
      }
    },
    comparison: {
      clientImg: '/images/employer/clientImg.webp',
      otherImg: '/images/employer/otherImg.webp',
    },
    howItWorksSection: {
      variant: 1,
      heroImage: '/images/employer/how-it-works-employer.webp',
      primaryButtonProps: {
        variant: 'outlined',
        color: 'secondary',
      },
    },
  },
  checkoutSection: {},
  findProviderSection: {
    locationWrapper: 7,
    mapWrapper: 5,
  },
  choosePlanSection: {
    sectionSubtitle: '',
    locationLogo: Logo,
    cardVariant: 2,
    tabVariant: 2,
    planCardProps: {
      buttonProps: {
        normalColor: 'primary',
        highlightedColor: 'primary',
        normalVariant: 'contained',
        highlightedVariant: 'outlined',
      },
      showMonthlyPriceForAnnual: true,
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
    },
  },
  subscriptionSuccess: {
    successImage: SuccessImage,
    enableBookAppointment: true,
    bookAppointmentProps: {
      link: bookAppointmentLink,
      target: '_blank',
    },
  },
  savingsSummary: {},
  faqSection: {},
  dashboardProps: {
    showBenefitsUsage: true,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
  },
  bookAppointment: {},
  footer: {
    enable: false
  },
  loginPage: {
    bannerImage: './images/login.webp',
  },
  theme: Theme,
};

export default config;
